import type { NextPage } from 'next';
import dynamic from 'next/dynamic';
import React from 'react';

import PageNextJs from 'nextjs/PageNextJs';

import config from 'configs/app';
import PageTitle from 'ui/shared/Page/PageTitle';

const UserOpBundles = dynamic(() => import('ui/pages/UserOpBundles'), { ssr: false });

const Page: NextPage = () => {
  const title = config.meta.seo.enhancedDataEnabled ?
    `${ config.chain.name } bundle transactions` :
    'Bundle transactions';

  return (
    <PageNextJs pathname="/bundles">
      <PageTitle title={ title } withTextAd/>
      <UserOpBundles hideTitle/>
    </PageNextJs>
  );
};

export default Page;

export { userOps as getServerSideProps } from 'nextjs/getServerSideProps';
